<template>
  <vs-popup
    :title="title"
    :active="inputValue"
    @close="inputValue = false"
  >
    <div class="px-4 text-left leading-loose">
      <slot name="content">
        {{ content }}
      </slot>
      <div
        v-if="!hideCancel"
        class="mt-4 flex justify-between"
      >
        <vs-button
          type="flat"
          @click="onClickCancel"
        >
          {{ cancelButtonText }}
        </vs-button>
        <vs-button
          @click="onClickConfirm"
        >
          {{ confirmButtonText }}
        </vs-button>
      </div>
      <div
        v-if="hideCancel"
        class="mt-4 text-right"
      >
        <vs-button
          type="border"
          @click="onClickConfirm"
        >
          {{ confirmButtonText }}
        </vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '登録'
    },
    content: {
      type: String,
      default: ''
    },
    cancelButtonText: {
      type: String,
      default: 'キャンセル'
    },
    confirmButtonText: {
      type: String,
      default: 'OK'
    },
    hideCancel: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'click:cancel', 'click:confirm'],
  computed: {
    inputValue: {
      get () {
        return this.modelValue
      },
      set (newValue) {
        return this.$emit('update:modelValue', newValue)
      }
    }
  },
  methods: {
    onClickCancel (event) {
      this.$emit('click:cancel', event)
    },
    onClickConfirm (event) {
      this.$emit('click:confirm', event)
    }
  }
}
</script>

<style scoped>

</style>
